// components/JobsList.js
import React from "react";

const JobsList = ({
  jobs,
  loading,
  onViewDetails,
  onShowErrors,
  onShowHistory,
  onStartReupload,
  onExport,
  onDelete,
  hasPermission,
}) => {
  if (loading) {
    return (
      <div className="card">
        <div style={{ textAlign: "center", padding: "40px" }}>
          <div className="spinner"></div>
          <p>กำลังโหลดข้อมูลงาน...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">รายการงาน</h3>
      </div>

      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>ชื่องาน</th>
              <th>วันที่สร้าง</th>
              <th>กำหนดเสร็จ</th>
              <th>ข้อผิดพลาด</th>
              <th>การดำเนินการ</th>
            </tr>
          </thead>
          <tbody>
            {jobs.length > 0 ? (
              jobs.map((job) => (
                <JobRow
                  key={job.id}
                  job={job}
                  onViewDetails={onViewDetails}
                  onShowErrors={onShowErrors}
                  onShowHistory={onShowHistory}
                  onStartReupload={onStartReupload}
                  onExport={onExport}
                  onDelete={onDelete}
                  hasPermission={hasPermission}
                  loading={loading}
                />
              ))
            ) : (
              <tr>
                <td
                  colSpan="5"
                  style={{ textAlign: "center", padding: "40px" }}
                >
                  ยังไม่มีงานในระบบ
                  <br />
                  <small>คลิก "สร้างงานใหม่" เพื่อเริ่มต้น</small>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const JobRow = ({
  job,
  onViewDetails,
  onShowErrors,
  onShowHistory,
  onStartReupload,
  onExport,
  onDelete,
  hasPermission,
  loading,
}) => {
  return (
    <tr>
      <td style={{ fontWeight: "600" }}>{job.job_name}</td>
      <td>{new Date(job.created_at).toLocaleDateString("th-TH")}</td>
      <td>
        {job.due_date
          ? new Date(job.due_date).toLocaleDateString("th-TH")
          : "-"}
      </td>
      <td>
        <ErrorStatusCell
          job={job}
          onShowErrors={onShowErrors}
          loading={loading}
        />
      </td>
      <td>
        <ActionButtons
          job={job}
          onViewDetails={onViewDetails}
          onShowHistory={onShowHistory}
          onStartReupload={onStartReupload}
          onExport={onExport}
          onDelete={onDelete}
          hasPermission={hasPermission}
          loading={loading}
        />
      </td>
    </tr>
  );
};

const ErrorStatusCell = ({ job, onShowErrors, loading }) => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      {job.total_records > 0 ? (
        <>
          <span
            className={`badge ${
              job.error_count > 0 ? "badge-error" : "badge-success"
            }`}
            style={{ fontSize: "12px" }}
          >
            {job.error_count}/{job.total_records}
          </span>
          {job.error_count > 0 && (
            <button
              className="btn btn-outline btn-sm"
              onClick={() => onShowErrors(job)}
              disabled={loading}
              style={{
                padding: "4px 8px",
                fontSize: "12px",
                color: "#ef4444",
                borderColor: "#ef4444",
              }}
              title={`ดูรายการข้อผิดพลาด ${job.error_count} รายการ`}
            >
              🔍 ดูข้อผิดพลาด
            </button>
          )}
        </>
      ) : (
        <span className="badge badge-warning" style={{ fontSize: "12px" }}>
          ไม่มีข้อมูล
        </span>
      )}
    </div>
  );
};

const ActionButtons = ({
  job,
  onViewDetails,
  onShowHistory,
  onStartReupload,
  onExport,
  onDelete,
  hasPermission,
  loading,
}) => {
  return (
    <div style={{ display: "flex", gap: "8px" }}>
      <button
        className="btn btn-outline btn-sm"
        onClick={() => onViewDetails(job)}
        title="ดูรายละเอียดงาน"
      >
        👁️ ดูรายละเอียด
      </button>

      <button
        className="btn btn-info btn-sm"
        onClick={() => onShowHistory(job)}
        disabled={loading}
        title="ดูประวัติการเปลี่ยนแปลงและข้อผิดพลาด"
      >
        📊 ประวัติ
      </button>

      {/* Show re-upload button for jobs with errors */}
      {hasPermission("canManageJobs") &&
        job.error_count > 0 &&
        job.status !== "FIXED" && (
          <button
            className="btn btn-warning btn-sm"
            onClick={() => onStartReupload(job)}
            disabled={loading}
            title={`อัปโหลด AR04 ใหม่เพื่อแก้ไขข้อผิดพลาด ${job.error_count} รายการ`}
          >
            📤 AR04 ใหม่
          </button>
        )}

      {hasPermission("canExportData") && (
        <button
          className="btn btn-success btn-sm"
          onClick={() => onExport(job.id, "complete")}
          title="ส่งออกข้อมูลงาน"
        >
          📥 ส่งออก
        </button>
      )}

      {hasPermission("canManageJobs") && (
        <button
          className="btn btn-outline btn-sm"
          onClick={() => onDelete(job)}
          disabled={loading}
          title="ลบงานและข้อมูลที่เกี่ยวข้องทั้งหมด"
          style={{
            color: "#ef4444",
            borderColor: "#ef4444",
          }}
        >
          🗑️ ลบ
        </button>
      )}
    </div>
  );
};

export default JobsList;
